import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import notify from "../../hook/useNotification";
import { loginUser } from "../../redux/actions/authActions";
import { storeNotLoginCartInBackEnd } from "../../redux/actions/cartAction";

const LoginHook = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [val, setVal] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(true);
  const [isPress, setIsPress] = useState(false);

  const onChangeVal = (e) => {
    setVal(e.target.value);
  };
  const onChangePassword = (e) => {
    setPassword(e.target.value);
  };

  const onSubmit = async () => {
    if (val === "") {
      notify("تاكد من الايميل او رقم الجوال", "error");
      return;
    }
    if (password === "") {
      notify("من فضلك ادخل الباسورد", "error");
      return;
    } else {
      setIsPress(true);
      setLoading(true);
      await dispatch(
        loginUser({
          val: val.toLocaleLowerCase(),
          password: password,
        })
      );
      setLoading(false);
      setIsPress(false);
    }
  };

  const loginWithOTP = async () => {
    if (val === "") {
      notify("تاكد من الايميل او رقم الجوال", "error");
      return;
    }
    else {
      setIsPress(true);
      setLoading(true);
      console.log('otpppppppppppppppp');
      // TODO: replace with specific OTP login action when available
      await dispatch(
        loginUser({
          val: `966${val}`,
          type: "otp",
        })
      );

      // /verifyCode/:id
      setLoading(false);
      setIsPress(false);
    }
  };
  const res = useSelector((state) => state.authReducers.loginUser);
  const settingsRes = useSelector((state) => state.settingsReducers.settings);

  console.log('loading', loading);

  useEffect(() => {
    const get = async () => {
      const cartItems = JSON.parse(localStorage.getItem('cart'));
      await dispatch(storeNotLoginCartInBackEnd({ items: cartItems, user: res }));

      console.log('after dispatch');

      setTimeout(() => {
        if (res.role === "admin") {
          window.location.href = "/admin/products";
        } else {
          // navigate(`/verifyCode/${res._id}`);
          // window.location.href = "/";
        }
      }, 1500);

    }

    if (loading === false) {
      if (res) {
        if (res.isVerified === false) {
          navigate(`/verifyCode/${res._id}`);
        } else {
          if (res.token) {
            localStorage.setItem("token", res.token);
            localStorage.setItem("user", JSON.stringify(res));

            notify("تم تسجيل الدخول بنجاح", "success");

            const cartItems = JSON.parse(localStorage.getItem('cart'));
            // خد ال cart من ال local storage وسجله
            if (cartItems && settingsRes?.data?.hasNotLoginCart == true) {
              // const cartItems=JSON.parse(localStorage.getItem('cart'));

              console.log('cartItems', cartItems);
              // لو ال cart موجود
              if (cartItems?.length > 0) {
                get();
              }



            }
            else {

              setTimeout(() => {
                if (res.role === "admin") {
                  window.location.href = "/admin/products";
                } else {
                  window.location.href = "/";
                }
              }, 1500);
            }

          } else {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            localStorage.removeItem("page");

          }
        }

        if (res.data) {
          if (
            res.data === "password is wrong" ||
            res.data === "The user not found"
          ) {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            notify("خطأ في البريد الالكتروني أو كلمة المرور   ", "error");

            setTimeout(() => {
              setLoading(true);
              setIsPress(false);
            }, 2000);

          }
          if (res.data === "The user is blocked") {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            notify("هذا المستخدم محظور من قبل الادارة", "error");

            setTimeout(() => {
              setLoading(true);
              setIsPress(false);
            }, 2000);

          }
        }

        // setLoading(true);
      }
    }
  }, [loading]);

  return [
    val,
    password,
    onChangeVal,
    onChangePassword,
    loading,
    onSubmit,
    isPress,
    loginWithOTP,
  ];
};

export default LoginHook;
